import React from 'react';
import { lazyForPaint, LazySuspense } from 'react-loosely-lazy';

import BaseRouteHandler from '../../Routes/components/common/routeHandlers/BaseRouteHandler';

const AppBundlesListRouteProcessor = lazyForPaint(() =>
  import(
    /* webpackPrefetch: true, webpackChunkName: "chunk-app-bundle-listing-page" */ '@atlassian/mpac-app-bundles/bundle-listing-page'
  ).then((c) => ({ default: c.BundleListingPage }))
);

const RouteHandler = (props) => {
  return (
    <BaseRouteHandler scrollToTopOnPathChange includePartnerQuickLinks>
      <LazySuspense fallback={<div />}>
        <AppBundlesListRouteProcessor {...props} />
      </LazySuspense>
    </BaseRouteHandler>
  );
};

export default RouteHandler;
